import { Dispatch } from 'redux'

import { SelectOptionLocal } from '../../../types/common/commonTypes'
import { apiInstance } from '../../api/apiInstance'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAllOilsVolumes =
    (searchTerm: string, typeId?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsVolumes', value: true } })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/dicts/avito/OilsVolumes', { typeId })
            const oilsVolumes: SelectOptionLocal[] = []

            if (status === 'ok') {
                const parser = new DOMParser()
                const xmlDoc = parser.parseFromString(data, 'text/xml')
                const volumesNodes = xmlDoc.getElementsByTagName('Volume')

                for (let i = 0; i < volumesNodes.length; i++) {
                    const volumeName = volumesNodes[i].textContent?.trim()
                    if (volumeName && volumeName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        oilsVolumes.push({ name: volumeName, value: volumeName })
                    }
                }
            }
            dispatch({ type: storeDispatchTypes.setAllOilsVolumes, value: { oilsVolumes } })
        } catch (e) {
            console.error('load oilsVolumes failed', e)
        }

        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsVolumes', value: false } })
    }

export default getAllOilsVolumes
